export default __webpack_public_path__ + "static/media/Path 85.753e370a.svg";